/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerievideoVideoidLangsAvailableLanguages200,
  GetApiV1SerievideoVideoidLangsAvailableLanguages401,
  GetApiV1SerievideoVideoidLangsAvailableLanguages404,
  GetApiV1SerievideoVideoidLangsAvailableLanguages500,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1SerievideoVideoidLangsAvailableLanguagesPathParamsSchema =
  z.object({
    videoId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams>;

export const getApiV1SerievideoVideoidLangsAvailableLanguagesQueryParamsSchema =
  z
    .object({
      serieId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerievideoVideoidLangsAvailableLanguages200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerievideoVideoidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerievideoVideoidLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerievideoVideoidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguages500>;

export const getApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1SerievideoVideoidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse>;
